import * as React from "react";

import { StyleSheet, View } from "react-native";

import { Colors } from "../../resources";

interface IProps {
  size: number;
  color?: string;
}

const ArrowRight: React.FC<IProps> = ({ size, color = undefined }) => {
  return (
    <View style={styles(size).container}>
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.3096 12.7784L14.5639 11.6809L18.6899 16.3963L14.5639 21.1117L13.3096 20.0142L16.4752 16.3963L13.3096 12.7784Z"
          fill={color}
        />
      </svg>
    </View>
  );
};

const styles = (size: number) => {
  return StyleSheet.create({
    container: {
      width: size,
      height: size,
      justifyContent: "center",
      alignItems: "center",
      borderWidth: 1,
      borderRadius: size / 2,
      borderColor: Colors.grey300,
    },
  });
};

export default ArrowRight;
